import { theme } from '@frontend/theme';

export const stepValueContainerStyles = {
  display: 'flex',
  rowGap: theme.spacing(2),
  fontWeight: theme.font.weight.bold,

  p: {
    whiteSpace: 'normal',
  },
};

export const overrideTextStyles = {
  fontWeight: 'normal',

  p: {
    whiteSpace: 'normal',
    span: {
      fontWeight: 'normal',
    },
  },
};
